import React from "react";

import Breadcrumbs from "../../../components/Breadcrumbs";
import Topbar from "../../../components/Topbar";

const THEME_COLOR = "#E13F57";

const buttonBaseStyle = {
  borderRadius: "10px",
  padding: "12px 24px",
  fontWeight: "500",
  fontSize: "14px",
  border: "none",
  transition: "all 0.3s ease",
};

const InitialDataFormLayout = ({
  name,
  entityPath,
  mode,
  children,
  onSubmit,
  onBack,
  onReset,
  onDelete,
  callInitialize,
  isSubmittingDisabled = false,
  submitLabelInsert = "บันทึก",
  submitLabelUpdate = "บันทึก",
  breadcrumbsItems = [],
  hideHeader = false,
  hidePageTitle = false,
  /** false = ไม่ห่อ children ใน card ใหญ่ (ใช้กับฟอร์มหลายการ์ด เช่น สินค้า) */
  contentCard = true,
  /** "product" = แถบล่างแบบย้อนกลับขอบแดง + บันทึกสีชมพูเท่านั้น */
  footerPreset = "default",
}) => {
  const isUpdate = mode === "U";
  const isProductFooter = footerPreset === "product";

  const resolvedBreadcrumbsItems =
    breadcrumbsItems.length > 0
      ? breadcrumbsItems
      : [
        { name, url: entityPath },
        {
          name: isUpdate ? `แก้ไข${name}` : `สร้าง${name}`,
          url: "#",
        },
      ];

  const isBackDisabled = typeof onBack !== "function" && typeof callInitialize !== "function";
  const isResetDisabled = typeof onReset !== "function";
  const isDeleteDisabled = !isUpdate || typeof onDelete !== "function";
  const isSubmitDisabled = isSubmittingDisabled || typeof onSubmit !== "function";

  const runBack = async () => {
    if (typeof callInitialize === "function") {
      try {
        await callInitialize();
        return;
      } catch (err) {
        console.error("callInitialize failed:", err);
      }
    }
    if (typeof onBack === "function") {
      try {
        onBack();
        return;
      } catch (err) {
        console.error("onBack handler failed:", err);
      }
    }
    if (entityPath) {
      window.location.href = entityPath;
    }
  };

  return (
    <>
      {!hideHeader && window.location.pathname !== "/purchase-order" && (
        <Topbar
          breadcrumbs={[
            { label: name, link: entityPath },
            { label: isUpdate ? `แก้ไข${name}` : `สร้าง${name}` },
          ]}
        />
      )}

      {!hideHeader && !hidePageTitle && (
        <div className={`page-header ${isProductFooter ? "mb-2" : "mb-3"}`}>
          <Breadcrumbs
            isShowStatus={isUpdate}
            items={resolvedBreadcrumbsItems}
          />
        </div>
      )}
      {!hideHeader && hidePageTitle && <div style={{ marginTop: "20px" }} />}

      <div
        className="container-fluid px-4"
        style={{ paddingTop: isProductFooter ? "0.25rem" : "1rem", paddingBottom: "1rem" }}
      >
        {contentCard ? (
          <div
            className="card shadow-sm mb-4 border-0"
            style={{ borderRadius: "12px", overflow: "hidden" }}
          >
            <div className="card-body p-4">{children}</div>
          </div>
        ) : (
          <div className="mb-4">{children}</div>
        )}

        <div
          className="card shadow-sm border-0"
          style={{ borderRadius: "12px", overflow: "hidden" }}
        >
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div className="d-flex flex-wrap gap-2">
                {!hideHeader && isProductFooter && (
                  <button
                    type="button"
                    onClick={runBack}
                    className="btn btn-lg d-flex align-items-center gap-2 bg-white"
                    style={{
                      ...buttonBaseStyle,
                      border: `2px solid ${THEME_COLOR}`,
                      color: THEME_COLOR,
                      opacity: isBackDisabled ? 0.6 : 1,
                      pointerEvents: isBackDisabled ? "none" : "auto",
                    }}
                  >
                    <i className="fas fa-arrow-left" />
                    <span>ย้อนกลับ</span>
                  </button>
                )}

                {!hideHeader && !isProductFooter && (
                  <>
                    <button
                      type="button"
                      onClick={runBack}
                      className="btn btn-lg d-flex align-items-center gap-2"
                      style={{
                        ...buttonBaseStyle,
                        backgroundColor: "#374151",
                        color: "#fff",
                        opacity: isBackDisabled ? 0.6 : 1,
                        pointerEvents: isBackDisabled ? "none" : "auto",
                      }}
                    >
                      <i className="fas fa-arrow-left" />
                      <span>กลับหน้ารายการ</span>
                    </button>
                    <button
                      type="button"
                      onClick={onReset}
                      className="btn btn-lg d-flex align-items-center gap-2"
                      style={{
                        ...buttonBaseStyle,
                        backgroundColor: "#0891b2",
                        color: "#fff",
                        opacity: isResetDisabled ? 0.6 : 1,
                        pointerEvents: isResetDisabled ? "none" : "auto",
                      }}
                    >
                      <i className="fas fa-redo" />
                      <span>เริ่มใหม่</span>
                    </button>
                  </>
                )}

                {!hideHeader && !isProductFooter && isUpdate && (
                  <button
                    type="button"
                    onClick={onDelete}
                    className="btn btn-lg d-flex align-items-center gap-2"
                    style={{
                      ...buttonBaseStyle,
                      backgroundColor: "#dc2626",
                      color: "#fff",
                      opacity: isDeleteDisabled ? 0.6 : 1,
                      pointerEvents: isDeleteDisabled ? "none" : "auto",
                    }}
                  >
                    <i className="fas fa-trash-alt" />
                    <span>ลบข้อมูล</span>
                  </button>
                )}
              </div>
              <div className="d-flex flex-wrap gap-2">
                <button
                  type="button"
                  onClick={onSubmit}
                  className="btn btn-lg d-flex align-items-center gap-2"
                  style={{
                    ...buttonBaseStyle,
                    paddingLeft: isProductFooter ? "28px" : "52px",
                    paddingRight: isProductFooter ? "28px" : "32px",
                    minWidth: "160px",
                    position: isProductFooter ? "relative" : "relative",
                    backgroundColor: isProductFooter ? THEME_COLOR : isUpdate ? "#f59e0b" : THEME_COLOR,
                    color: "#fff",
                    boxShadow: isProductFooter
                      ? "0 4px 12px rgba(225, 63, 87, 0.3)"
                      : `0 4px 12px ${isUpdate ? "rgba(245, 158, 11, 0.3)" : "rgba(225, 63, 87, 0.3)"}`,
                    opacity: isSubmitDisabled ? 0.6 : 1,
                    pointerEvents: isSubmitDisabled ? "none" : "auto",
                  }}
                  onMouseOver={(event) => {
                    if (isSubmitDisabled) return;
                    event.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseOut={(event) => {
                    if (isSubmitDisabled) return;
                    event.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  {!isProductFooter && (
                    <i
                      className="fas fa-save"
                      style={{
                        position: "absolute",
                        left: "18px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "16px",
                      }}
                    />
                  )}
                  {isProductFooter && <i className="fas fa-save me-2" />}
                  <span>{isUpdate ? submitLabelUpdate : submitLabelInsert}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InitialDataFormLayout;
